import { createStore, action } from "easy-peasy"

export default createStore({
  authUser: null,
  setAuthUser: action((state, authUser) => {
    if (authUser === null || authUser === undefined) {
      state.authUser = null
    } else {
      state.authUser = authUser
    }
  }),
  user: null,
  setUser: action((state, user) => {
    if (user === null || user === undefined) {
      state.user = null
    } else {
      state.user = user
    }
  }),
  aliasedUser: null,
  setAliasedUser: action((state, aliasedUser) => {
    if (aliasedUser === null || aliasedUser === undefined) {
      state.aliasedUser = null
    } else {
      state.aliasedUser = aliasedUser
    }
  }),
  triggerUsersSwimmersRefresh: 0,
  setTriggerUsersSwimmersRefresh: action(
    (state, triggerUsersSwimmersRefresh) => {
      state.triggerUsersSwimmersRefresh = triggerUsersSwimmersRefresh
    },
  ),
  aliasedClub: null,
  setAliasedClub: action((state, aliasedClub) => {
    if (aliasedClub === null || aliasedClub === undefined) {
      state.aliasedClub = null
    } else {
      state.aliasedClub = aliasedClub
    }
  }),
  acceptedCookies: false,
  setAcceptedCookies: action((state, acceptedCookies) => {
    state.acceptedCookies = !!acceptedCookies
  }),
  seasonPrepModal: null,
  setSeasonPrepModal: action((state, whichModal) => {
    state.seasonPrepModal = whichModal
  }),
  // --- Club Curriculum Assignments State ---
  clubAssignments: {}, // curriculumId -> assignments array

  setClubAssignments: action((state, payload) => {
  // payload expected like: { [curriculumId]: assignmentsArray }
  console.log("setClubAssignments payload", payload);
  state.clubAssignments = {
    ...(state.clubAssignments || {}),
    ...payload,
  };
}),
  
  loadingAssignments: {}, // curriculumId -> boolean

  setLoadingAssignments: action((state, payload) => {
    // payload should be an object: { [curriculumId]: boolean }
    state.loadingAssignments = { ...state.loadingAssignments, ...payload };
  }),
})
